import styled from "styled-components";

export const Select = styled.select`
    width: 100%;
    max-width: 300px;
    padding: 0.5em;
    border-radius: 0;
    appearance: none;
    color: ${props => props.theme.secondary};
    box-sizing: border-box;
    text-align: left;
    display: block;
    font: inherit;
    font-size: 0.875rem;
    border: none;
    margin-left: auto;
    margin-right: auto;

    ::-ms-expand {
        display: none;
    }

    cursor: ${props => (props.disabled ? "not-allowed" : "pointer")};
    background: ${props =>
        props.disabled ? "rgba(112, 101, 93, 0.25) !important" : props.theme.tertiary};
`;
